/* eslint-disable @typescript-eslint/naming-convention */
export enum MapType {
  'DEFAULT',
  'SCENE',
}
